@if (data) {
    <cerrix-workspace
        [tabID]="tabID"
        [cerrixTab]="tab"
        [data]="data"
        [headerLookup]="headerLookup"
        [module]="'moi'"
        [moduleType]="moduleType"
        [idProp]="'guid'"
        [permissions]="permissions"
        [filterConfig]="filterConfigs"
        [rendererConfig]="rendererConfig"
        [NumberProperties]="numberProps"
        [DateProperties]="dateProps"
        (onAddClick)="addMoi()"
        (onDblClick)="openMoi($event)"
        (onServerFiltersApplied)="getData($event)"
    >
    </cerrix-workspace>
}
